import react from "react";
import AboutHeroBanner from "../components/aboutUs/AboutHeroBanner ";
import AboutStory from "../components/aboutUs/AboutStory ";
import WhatWeDoSection from "../components/aboutUs/WhatWeDoSection";
import VisionMission from "../components/aboutUs/VisionMission ";
import WhyChooseUs from "../components/aboutUs/WhyChooseUs";
import CommonCTA from "../components/commonComponents/CommonCTA";
import SEO from "../components/commonComponents/SEO";

export default function AboutUs() {
  return (
    <>
      <SEO
        title="About ZENCON | SAP Consulting & Digital Transformation Company"
        description="ZENCON Ltd. Co. is a leading SAP consulting and enterprise technology company in Saudi Arabia delivering SAP implementation, digital transformation, cloud services, automation, and business solutions across global markets."
        keywords="About ZENCON, SAP consulting company Saudi Arabia, SAP implementation company, enterprise technology solutions, digital transformation company, SAP S4HANA experts, SAP services KSA"
        url="https://www.zencon-sa.com/about"
        image="https://www.zencon-sa.com/images/default-image.png"
      />
      <AboutHeroBanner />
      <AboutStory />
      <WhatWeDoSection />
      <VisionMission />
      <WhyChooseUs />
      <CommonCTA />
    </>
  );
}
